import { Component, OnDestroy, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ReportingService } from '../reporting.service';

@AutoUnsubscribe()
@Component({
    selector: 'ConfirmModal',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.css']
})

export class ConfirmModalComponent implements OnDestroy, OnInit {

    PageTitle: string;
    Message: string;

    constructor(
        private reportService: ReportingService,
        private dialogRef: MatDialogRef<ConfirmModalComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
    ) {
        this.PageTitle = data.PageTitle;
        this.Message = data.Message;
    }

    ngOnInit() {

    }

    ngOnDestroy() {
    }

    okClick() {
        this.dialogRef.close(true);
    }

    continueWithoutSavingClick() {
        this.dialogRef.close('ContinueWithoutSaving');
    }

    cancelClick() {
        this.dialogRef.close(false);
    }


}
